<template>
	<div>
		<div class="col-md-12">
			<div class="row">
				<div class="col-md-7">
					<h3 class="page-header">
						<i class="fa fa-inr animated bounceInDown show-info"></i>
						Payroll Runs
					</h3>
				</div>
				<div class="col-md-5 text-right" style="margin-top:20px">
					<button class="btn btn-primary" @click="openMonth" :disabled="opening">
						<i class="fa fa-plus"></i>
						{{ opening ? 'Opening…' : 'Open a month' }}
					</button>
				</div>
			</div>
		</div>

		<div class="col-md-12">
			<div class="row stock_section">
				<div class="col-md-4">
					<label>Month</label>
					<div style="display:flex;align-items:center">
						<button class="btn btn-default" @click="month = shiftMonthValue(month, -1)">
							<i class="fa fa-chevron-left"></i>
						</button>
						<input
							type="month"
							class="form-control form-cascade-control input-box-short"
							style="margin:0 8px"
							v-model="month"
						/>
						<button class="btn btn-default" @click="month = shiftMonthValue(month, 1)">
							<i class="fa fa-chevron-right"></i>
						</button>
					</div>
				</div>
				<div class="col-md-8" style="margin-top:26px">
					<span class="text-muted">
						Opening a month is safe — it creates a draft, or reopens the one already there.
						Nothing is committed until the run is approved.
					</span>
				</div>
			</div>
		</div>

		<div class="col-md-12">
			<div class="panel">
				<div class="panel-body" style="background:none">
					<div v-if="error" class="alert alert-danger">{{ error }}</div>
					<div v-if="loading" class="text-muted">Loading…</div>

					<table v-else class="table table-bordered table-hover table-striped display">
						<thead class="table-font" style="background:#475c78;color:#fff">
							<th>#</th>
							<th>Period</th>
							<th>Employees</th>
							<th class="text-right">Gross</th>
							<th class="text-right">Deductions</th>
							<th class="text-right">Net</th>
							<th class="text-right">Recovered</th>
							<th>Status</th>
							<th></th>
						</thead>
						<tbody class="table-font">
							<tr v-for="(run, index) in runs" :key="run.id">
								<td>{{ index + 1 }}</td>
								<td>
									<strong>{{ monthLabel(run.cycle_label) }}</strong>
									<div class="text-muted" style="font-size:11px">
										{{ formatDate(run.period_start) }} – {{ formatDate(run.period_end) }}
									</div>
								</td>
								<td>{{ run.employee_count }}</td>
								<td class="text-right">{{ moneyShort(run.total_gross) }}</td>
								<td class="text-right">{{ moneyShort(run.total_deductions) }}</td>
								<td class="text-right"><strong>{{ moneyShort(run.total_net) }}</strong></td>
								<td class="text-right">{{ moneyShort(run.total_recoveries) }}</td>
								<td><span :class="runStatusClass(run.status)">{{ runStatusLabel(run.status) }}</span></td>
								<td>
									<button class="badge bg-primary" @click="open(run)">Open</button>
								</td>
							</tr>
							<tr v-if="!runs.length">
								<td colspan="9" class="text-center text-muted" style="padding:24px">
									No payroll runs yet. Pick a month above and open it.
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { runService, errorMessage } from './payrollService'
import payrollFormat from './payrollFormat'
import { mapGetters } from 'vuex'

/**
 * The list of periods.
 *
 * A run is created here and computed on the next screen, because opening a month
 * and committing money to it are different decisions and should not be one
 * button.
 */
export default {
	name: 'PayrollRuns',
	mixins: [payrollFormat],
	data() {
		return {
			month: this.currentMonth(),
			runs: [],
			loading: false,
			opening: false,
			error: '',
		}
	},
	computed: {
		...mapGetters(['selectedstoreid']),
	},
	mounted() {
		this.refresh()
	},
	methods: {
		refresh() {
			this.loading = true
			this.error = ''
			runService
				.list()
				.then((data) => {
					this.runs = data || []
				})
				.catch((e) => {
					this.error = errorMessage(e, 'Could not load payroll runs.')
				})
				.finally(() => {
					this.loading = false
				})
		},
		/**
		 * The server decides the actual period from the attendance cycle, so a
		 * company on a 26th-to-25th month gets that here without this screen
		 * knowing about it.
		 */
		openMonth() {
			this.opening = true
			runService
				.open(this.month, this.selectedstoreid || 0)
				.then((run) => {
					this.$router.push({ name: 'payroll-run', params: { id: run.id } })
				})
				.catch((e) => {
					this.$notify({ text: errorMessage(e, 'Could not open that month.'), type: 'error' })
				})
				.finally(() => {
					this.opening = false
				})
		},
		open(run) {
			this.$router.push({ name: 'payroll-run', params: { id: run.id } })
		},
	},
}
</script>

<style scoped>
.text-right {
	text-align: right;
}
</style>
